export const buildQuery = (start_date=null, end_date=null, title=null, tags=null, ordering=null) => [
    start_date && `start_date=${start_date}`,
    end_date && `end_date=${end_date}`,
    title && `title=${encodeURIComponent(title)}`,
    tags && `tags=${tags.map(encodeURIComponent).join(',')}`,
    ordering && `ordering=${ordering}`,
].filter(Boolean).join('&')

// Same as buildQuery, but `tags` is the comma-joined string read from the URL.
export const buildSearchQuery = (start_date=null, end_date=null, title=null, tags=null, ordering=null) =>
    buildQuery(start_date, end_date, title, tags ? tags.split(',') : null, ordering)
